module.exports = __webpack_public_path__ + "static/media/goal1.9b84e7d7.svg";